<script setup lang="ts">
import Button from '@/components/UIComponents/BaykusButton/BaykusButton.vue'
import { useGeneralStore } from '@/stores/general'
import Input from '@/components/UIComponents/BaykusInput/BaykusInput.vue'
import IconCommunity from '@/components/icons/IconCommunity.vue'
import { parseToken } from '../utils/Utils'
const store = useGeneralStore()
const changeTheme = () => {
  if (store.getColorSchema === 'light') {
    store.TOGGLE_THEME('dark')
    return
  }
  if (store.getColorSchema === 'dark') {
    store.TOGGLE_THEME('light')
  }
}
</script>

<template>
  <div class="container mx-auto flex flex-col w-full h-screen justify-center items-center">
    {{ parseToken() }}
    <div class="flex gap-4">
      <Button @click="changeTheme" type="primary" :size="'sm'"> Tema Degistir </Button>
      <RouterLink to="/auth/login" type="primary" :size="'sm'"> Login Sayfasina git </RouterLink>
    </div>
    <span class="text-gray-700 block my-4"
      >Selected Theme: {{ store.getTheme === 'system' ? 'System - ' : '' }}
      {{ store.getColorSchema }}</span
    >
    <Input label="input" name="test" :error="true">
      <template #icon>
        <IconCommunity class="text-gray-400 w-[24px] h-[24px]" />
      </template>
    </Input>
    <Input label="input" name="deneme">
      <template #icon>
        <IconCommunity class="text-gray-400 w-[24px] h-[24px]" />
      </template>
    </Input>
    <Input label="input" name="deneme2" />
    <Input label="input" name="deneme 3" :error="true" />
  </div>
</template>
